export default [
    {
        path: '/games/golden-eggs/index',
        component: (resolve) => require(['@/components/games/goldenEggs/Index'],resolve),
        meta: {
            title: '砸金蛋',
            loginIn: true,
        },
    },
    {
        path: '/games/scratchCard/index',
        component: (resolve) => require(['@/components/games/scratchCard/Index'],resolve),
        meta: {
            title: '刮刮卡',
            loginIn: true,
        },
    },
    {
        path: '/games/lookPic/index',
        component: (resolve) => require(['@/components/games/lookPic/Index'],resolve),
        meta: {
            title: '看图答题',
            loginIn: true,
        },
    },
    {
        path: '/games/setTheCard/index',
        component: (resolve) => require(['@/components/games/setTheCard/Index'],resolve),
        meta: {
            title: '集福卡',
            loginIn: true,
        },
    },
    {
        path: '/games/grabRedPackage/index',
        component: (resolve) => require(['@/components/games/grabRedPackage/Index'],resolve),
        meta: {
            title: '瓜分红包',
            loginIn: true,
        },
    },
    {
        path: '/games/examHelp/index',
        component: (resolve) => require(['@/components/games/examHelp/Index'],resolve),
        meta: {
            title: '高考冲刺助力',
            loginIn: true,
        },
    },
    {
        path: '/games/flipCards/index',
        component: (resolve) => require(['@/components/games/flipCards/Index'],resolve),
        meta: {
            title: '翻牌消除',
            loginIn: true,
        },
    },
    {
        path: '/games/slapBoyFriend/index',
        component: (resolve) => require(['@/components/games/slapBoyFriend/Index'],resolve),
        meta: {
            title: '掌刮男朋友',
            loginIn: true,
        },
    },
    {
        path: '/games/lipstickMachine/index',
        component: (resolve) => require(['@/components/games/lipstickMachine/Index'],resolve),
        meta: {
            title: '口红机',
            loginIn: true,
        },
    },
    {
        path: '/games/protectGod/index',
        component: (resolve) => require(['@/components/games/protectGod/Index'],resolve),
        meta: {
            title: '保护神',
            loginIn: true,
        },
    },
]



// WEBPACK FOOTER //
// ./src/router/games.js